import gear from "./media/recovery-4.svg";

export const ONE_HOT_MODE = true;

export const REGRESSSION_MODELS = {
	linReg: "Lin. Regression",
	ridgeReg: "Ridge Regression",
	knn: "K-NN",
	randomForest: "Random Forest",
	svm: "Support Vector Machines",
	neuralNet: "Neural Network",
};
export const CLASSIFICATION_MODELS = {
	logistic: "Logistic",
	bayes: "Naive Bayes",
	knn: "K-NN",
	randomForest: "Random Forest",
	svm: "Support Vector Machines",
	neuralNet: "Neural Network",
};
export const TOTAL_PROGRESS_WEIGHTS = {
	"Lin. Regression": 1,
	"Ridge Regression": 1,
	"K-NN": 1,
	"Random Forest": 4,
	"Support Vector Machines": 2,
	"Neural Network": 7,
	Logistic: 2,
	"Naive Bayes": 1,
};
export const DATA_TYPES = {
	number: "Number",
	categorical: "Categorical",
	unusable: "Unusable",
};
export const ALL_MODELS = { ...REGRESSSION_MODELS, ...CLASSIFICATION_MODELS };
export const MODEL_STATES = {
	ready: 0,
	training: 1,
	trained: 2,
	premOnly: 3,
	unselected: 4,
};
export const FILTER_OPS_CAT = {
	equal: "Equal",
	notEqual: "Not Equal",
};
export const FILTER_OPS_NUM = {
	equal: "Equal",
	notEqual: "Not Equal",
	greater: "Greater Than",
	less: "Less Than",
};

export const MIN_FREQ_CLASS = 0.05; // Minimum amount of examples to not be grouped into a general sparse class
export const TEST_SPLIT = 0.2;
export const DROP_BOX = { trainData: 0, testData: 1 };
export const SORT_TYPES = { asc: "0", desc: "1" };

export const PCA_ENCODE = false;
export const DELIMINATOR = "</88-av>";
export const WORKER_TYPES = {
	trainer: 0,
	trainDataProcessor: 1,
	processDroppedData: 2,
	batchPrediction: 3,
	applyFiltersToDash: 4,
	postTrainProcess: 5,
	customTopics: 6,
	applyTopics: 7,
	gzip: 8,
};
export const MAX_ROWS_SLOW = 5000;
export const MAX_ROWS_FAST = 1000;
export const MIN_ROWS = 50;
export const MAX_CLASSES_FOR_NUMBER = 12;
export const MAX_CLASSES_PER_COL = 30;

export const DOMAIN =
	process.env.NODE_ENV === "development"
		? "http://localhost:3000"
		: "https://dash-ai.app";
export const GOOGLE_CLIENT_ID =
	"268337837043-7903p9p9uhg9k73sfug3rogu86imjtut.apps.googleusercontent.com";

export const PREM_MODELS = new Set([ALL_MODELS.svm, ALL_MODELS.neuralNet]);

//Colors
export const PURPLE = "#76078f";

// Analytics
// Category
export const PURCHASE_FLOW = "Purchase Flow";
export const LOG_IN = "Log In";
export const DASHBOARD_USE = "Dashboard Use";
//Action
export const NAV_LOG_IN_BUTTON = "NAV Log In";
export const NAV_USE_IT = "NAV Use It";
export const NAV_HOW_IT_WORKS = "NAV How It Works";
export const LOG_IN_POPUP = "Log In Popup Click";
export const NAV_PURCHASE_BUTTON = "NAV Purchase";
export const SUB_CLICK_M = "Monthly Sub";
export const SUB_CLICK_Y = "Yearly Sub";
export const VIDEO_CLICK = "Video Click";
export const TRAIN_MODELS = "Train Models";
export const CANCEL_TRAIN_MODELS = "Cancel Train Models";
export const DASH_DROPDOWN = "Dash Dropdown";
export const NEW_DASH = "New Dashboard";
export const SAVE_DASH = "Save Dashboard";
export const CHANGE_DASH = "Change Dashboard";
export const TIPS_POPUP = "Tips Popup";
export const TRAIN_DROP = "Train Drop";
export const TOGGLE_MODEL = "Toggle Model";
export const VALUE_TO_PREDICT = "Value to Predict Change";
export const PREDICTOR_INPUT = "Predictor Inputs";
export const MAKE_PREDICTION = "Make Prediction Button";
export const BATCH_DROP = "Batch Drop";
export const LOG_OUT_CLICK = "Log Out Click";
export const GO_PREM = "Go Premium";
export const DROP_REJECT = "Drop Rejected";

//Label
export const LOGGED_IN = "Logged In";
export const NOT_LOGGED_IN = "Not Logged In";
export const PURCHASED = "Purchased";
export const NOT_PURCHASED = "Not Purchased";

// Box states
export const HIST_CHART_SELECTED = { num: 0, cat: 1, dropped: 3 };

// Colors
export const BOX_SHADOWS = "rgba(21, 32, 52, 0.35) 0px 2px 6px;";
export const SECONDARY_COLOR = "#051937";
export const PRIMARY_COLOR = "#3A3845";
export const THIRD_COLOR = "#FF2E63";

export const GRAY = "white";
export const SECONDARY_COLOR_RGB = [255, 46, 99];
export const PRIMARY_COLOR_RGB = [37, 42, 52];

// Routes
const home = "/dashboard";
const articles = "/applications/";
export const ARTICLES = {
	sales_leads: "Sales Lead Scoring",
	finance: "Financial Markets",
	csat: "Customer Satisfaction",
	purchase: "Purchase Prediction",
	fraud: "Fraud Detection",
	property: "Property Prices",
	credit: "Credit Risk",
};

export const ROUTES = {
	data_ingestion: home + "/dataUpload",
	data_cleaning: home + "/cleaning",
	persona_groupings: home + "/clustering",
	variable_correlation: home + "/correlations",
	cohort_analysis: home + "/cohorts",
	model_training: home + "/training",
	nlp: home + "/topicModeling",
	sentiment: home + "/sentimentAnalysis",
	var_importance: home + "/importance",
	persona_prediction: home + "/personaPrediction",
	batch_prediction: home + "/batchPrediction",
	account_settings: home + "/account",
	client_api: home + "/APIExport",
	email_sent: "/emailSent",
	faq: "/faq",
	logout: "/logout",
	login: "/login",
	signup: "/signup/*",
	demo: "/bookADemo",
	privacy: "/privacy",
	legal: "/legal",
	applications: "/applications",
	error: "/errorPage",
	forgot_pass: "/forgotPassword",
	pass_reset: "/passwordReset/*",
	verified_page: "/verified",

	// Articles
	sales_leads: articelRoute(ARTICLES.sales_leads),
	finance: articelRoute(ARTICLES.finance),
	csat: articelRoute(ARTICLES.csat),
	purchase: articelRoute(ARTICLES.purchase),
	fraud: articelRoute(ARTICLES.fraud),
	property: articelRoute(ARTICLES.property),
	credit: articelRoute(ARTICLES.credit),
};
function articelRoute(val: string) {
	return articles + val.replaceAll(" ", "").toLowerCase();
}
export const ARTICLE_ROUTES = {};
ARTICLE_ROUTES[ARTICLES.sales_leads] = ROUTES.sales_leads;
ARTICLE_ROUTES[ARTICLES.finance] = ROUTES.finance;
ARTICLE_ROUTES[ARTICLES.csat] = ROUTES.csat;
ARTICLE_ROUTES[ARTICLES.purchase] = ROUTES.purchase;
ARTICLE_ROUTES[ARTICLES.fraud] = ROUTES.fraud;
ARTICLE_ROUTES[ARTICLES.property] = ROUTES.property;
ARTICLE_ROUTES[ARTICLES.credit] = ROUTES.credit;

export const PAIR_PLOT_RADIALS = {
	counts: "Counts",
	percentage: "Percentage",
	total_percent: "Total Percentage",
};
export const CHART_TYPES = {
	table: "Table",
	table_heat: "Table Heatmap",
	table_heat_col: "Table Col. Heatmap",
	table_heat_row: "Table Row Heatmap",
	grouped_col: "Grouped Column Chart",
	stacked_col: "Stacked Column Chart",
	grouped_bar: "Grouped Bar Chart",
	stacked_bar: "Stacked Bar Chart",
	line_chart: "Line Chart",
	area_chart: "Area Chart",
	pie_charts: "Pie Charts",
	pie_charts_3d: "Pie Charts 3D",
	pie_donut: "Donut Charts",
};

export const AGG_TYPES = {
	sum: "Sum",
	percentage_total: "Total Percentage",
	percentage_row: "Row Percentage",
	percentage_col: "Column Percentage",
	count: "Count",
	average: "Average",
	median: "Median",
	unique: "Unique Values Count",
};

export const AGG_TYPES_NUMERIC = {
	sum: "Sum",
	percentage_total: "Total Percentage",
	percentage_row: "Row Percentage",
	percentage_col: "Column Percentage",
	count: "Count",
	average: "Average",
	median: "Median",
};

export const AGG_TYPES_CATEGORICAL = {
	percentage_total: "Total Percentage",
	percentage_row: "Row Percentage",
	percentage_col: "Column Percentage",
	count: "Count",
};

export const CLEAN_FILTERS_OP = {
	replace: "Replace Value",
	drop: "Drop Row",
};

export const DATA_CLEAN_FILTERS_CAT = {
	equal: "Equal",
	not_equal: "Not Equal",
};
export const DATA_CLEAN_FILTERS_NUM = {
	equal: "Equal",
	not_equal: "Not Equal",
	greater: "Greater Than",
	less: "Less Than",
};

export const OP_SYMBLS = {
	Equal: "=",
	"Not Equal": "≠",
	"Greater Than": ">",
	"Less Than": "<",
};

export const FONTS = "Trebuchet MS, Arial, sans-serif";
export const FONTS2 = "nationalweb,Helvetica,Arial,sans-serif";

export const EMPTY_MESSAGE_IMAGES = {
	pleaseTrain: gear,
	noData: gear,
};

export const EMPTY_MESSAGES = {
	train1: "Please Train a Model First.",
	train2: "You must train at least one model on the 'Model Training' tab first.",
	empty1: "No Data.",
	empty2Num: "Your dataset has no Numeric columns to display.",
	empty2Cat: "Your dataset has no Categorical columns to display.",
	noVarImportance1: "No Important Variables",
	noVarImportance2:
		"No variables were found to have any predictive power for '{r1}'.",
	noText1: "No Text Columns Found",
	noText2: "Your data does not have any natural language text columns.",
	filteredOut: "All your data has been filtered out.",
};

export const EXTRA_HEADERS = {
	predited: "Predicted: {val}",
	probabilites: "Probability (%)",
	row_number: "Row Number",
};

export const DROP_TYPES = { main: 0, newDashPopup: 1, batch: 2 };
console.log(process.env.NODE_ENV);
export const GOOGLE_ANALYTICS_ID =
	process.env.NODE_ENV != "development" ? "UA-215328387-1" : null;
export const GOOGLE_ADS_ID = "AW-10825489358";
